module.exports = __webpack_public_path__ + "static/media/photo200.62418b93.jpg";